import type { FooterColLinks } from '../../../types/footer';
import type { Link } from '../../../types/link';
import type { Translations } from '../../../types/translations';
import { getItemLinkRefUrl } from '../../../utils/itemLinkRef';

export const mapNavigation = ({
  col,
  index,
  translations,
  instance,
}: {
  col: FooterColLinks;
  index: number;
  translations?: Translations;
  instance?: string;
}) => {
  const baseKey = `footer.column.headline.${index + 1}`;

  let title = translations?.[baseKey];

  if (instance === 'shop') {
    title = translations?.[`${baseKey}.shop`];
  } else if (['microsite', 'microsite_hr', 'microsite-hr'].includes(instance!)) {
    title = translations?.[`${baseKey}.microsite`];
  }

  return {
    type: 'navigation',
    id: index,
    title: col.st_headline ?? title ?? '',
    items: col.st_elements?.value.flatMap((element) =>
      element.st_link_list_items?.value.map(
        (item, subitemIndex) =>
          ({
            id: subitemIndex.toString(),
            label: item.lt_link_text,
            url: getItemLinkRefUrl(item),
            target: item.lt_link_target as Link['target'],
            noFollow: item.lt_link_nofollow,
          }) as const,
      ),
    ) satisfies Link[],
  } as const;
};
